import { AbstractModelSchema } from './abstract_model_schema.js';
export const dictionaryWordSchema = {
    displayName: 'glossary term',
    type: 'object',
    fields: {
        ...AbstractModelSchema.fields,
        orgId: {
            type: 'mongoId',
            isHidden: true,
            isReadOnly: true,
        },
        locationId: {
            type: 'mongoId',
            isHidden: true,
            isReadOnly: true,
        },
        menuId: {
            type: 'mongoId',
            isHidden: true,
            isReadOnly: true,
        },
        name: {
            displayName: 'Text to match',
            type: 'shortString',
            required: true,
            tooltip: {
                text: 'All text in menu item descriptions, stories and modifier lists that matches this text (case-insensitive) will become a glossary term.',
            },
            canHaveLocalizationOverrides: true,
        },
        simpleDescription: {
            displayName: 'Simple Description',
            type: 'longString',
            required: true,
            tooltip: {
                text: 'Description of the term. Describe what the thing is.',
            },
            canHaveLocalizationOverrides: true,
        },
        detailedDescription: {
            displayName: 'Detailed Description',
            type: 'longString',
            tooltip: {
                text: 'Additional description of the term. Describe tasting notes or interesting facts.',
            },
            canHaveLocalizationOverrides: true,
        },
        images: {
            type: 'array',
            elementType: 'object',
            elementSubtype: 'Image',
            elementUniqueIdFieldName: 'origUrl',
            maxCount: 1,
            forceCrop: true,
            size: {
                width: 250,
                height: 250,
            },
            canHaveLocalizationOverrides: true,
        },
    },
};
//# sourceMappingURL=dictionary_word_schema.js.map